import Axios from "../config/config";

//Announcement

export const UPDATE_LEADERBOARD= async (body) => {
    try {
        const response = await Axios.post('update-leaderboard/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EMPTY_LEADERBOARD= async (body) => {
    try {
        const response = await Axios.post('empty-leaderboard/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};